import React from 'react'
import useSmartviewManager from './use-smartview-manager'
import useOnSmartviewMount from './use-on-smartview-mount'

export default function useIsSmartviewMounted () {
  const smartviewManager = useSmartviewManager()

  const [isMounted, setIsMounted] = React.useState(smartviewManager.smartview !== null)

  useOnSmartviewMount(() => {
    const nextIsMounted = smartviewManager.smartview !== null

    if (nextIsMounted !== isMounted) {
      setIsMounted(nextIsMounted)
    }
  }, [isMounted])

  return isMounted
}
